import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const preqPartBrand = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/prerequisite/part-brands',

        partCategories: [],
        partCategoriesLoading: false,
        partCategoryLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        partCategories: state => state.partCategories,
    },
};
